import _ from 'lodash';
import { useState } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING, LOCAL_STORAGE_KEYS } from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';

export const useProjectsLocalStorage = () => {
  const localStorageAccessor = BrowserStorageAccessor().local;
  const localStorageEstimationFields =
    JSON.parse(
      localStorageAccessor.get(LOCAL_STORAGE_KEYS.PROJECTS_ISSUES_TYPES)
    ) || {};

  const localStorageExcludedIssues =
    JSON.parse(
      localStorageAccessor.get(LOCAL_STORAGE_KEYS.PROJECTS_EXCLUDED_ISSUES)
    ) || null;

  const [projectsExcludedIssues, setProjectsExcludedIssues] = useState(
    localStorageExcludedIssues
  );
  const [projectsEstimationFields, setProjectsEstimationFields] = useState(
    localStorageEstimationFields
  );

  const storeProjectsEstimations = (
    projectName,
    issueType,
    estimations,
    projectEstimation,
    setProjectsEstimationFields
  ) => {
    TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
      page: TRACKING.PAGES.PROJECTS,
      filter_name: TRACKING.FILTER.PROJECT_FILTER_ESTIMATIONS,
      filter_value: projectEstimation[issueType],
      project_name: projectName
    });

    localStorageAccessor.set(
      LOCAL_STORAGE_KEYS.PROJECTS_ISSUES_TYPES,
      JSON.stringify(estimations)
    );

    setProjectsEstimationFields(estimations);
  };

  const storeProjectsExcludedIssues = (
    projectName,
    name,
    excluded,
    setProjectsExcludedIssues
  ) => {
    TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
      page: TRACKING.PAGES.PROJECTS,
      filter_name: TRACKING.FILTER.PROJECT_FILTER_CHART,
      filter_value: name,
      project_name: projectName
    });

    localStorageAccessor.set(
      LOCAL_STORAGE_KEYS.PROJECTS_EXCLUDED_ISSUES,
      _.isEmpty(excluded) ? null : JSON.stringify(excluded)
    );

    setProjectsExcludedIssues(excluded);
  };

  return {
    projectsEstimationFields,
    setProjectsEstimationFields,
    storeProjectsEstimations,
    projectsExcludedIssues,
    setProjectsExcludedIssues,
    storeProjectsExcludedIssues
  };
};
